<template>
  <BaseExportModal
    ref="exportModal"
    module-name="nhà cung cấp"
    :export-service="ProviderService"
    :search-params="searchParams"
    :total-items="totalItems"
    :field-options="fieldOptions"
    :default-selected-fields="defaultSelectedFields"
    default-file-name="danh-sach-nha-cung-cap"
    :filter-mapping="filterMapping"
    @export-success="$emit('export-success')"
  />
</template>

<script>
import BaseExportModal from './BaseExportModal.vue';
import { ProviderService } from '../service/provider.service';

export default {
  name: 'ProviderExportModal',
  components: {
    BaseExportModal,
  },
  props: {
    searchParams: {
      type: Object,
      default: () => ({}),
    },
    totalItems: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ProviderService,
      defaultSelectedFields: [
        'code',
        'name',
        'type',
        'phoneNo',
        'email',
        'address',
      ],
      fieldOptions: [
        { text: 'Mã nhà cung cấp', value: 'code' },
        { text: 'Tên nhà cung cấp', value: 'name' },
        { text: 'Loại', value: 'type' },
        { text: 'Nhóm nhà cung cấp', value: 'supplierGroupName' },
        { text: 'Điện thoại', value: 'phoneNo' },
        { text: 'Email', value: 'email' },
        { text: 'Mã số thuế', value: 'taxNo' },
        { text: 'CMND/CCCD', value: 'identityCard' },
        { text: 'Địa chỉ', value: 'address' },
        { text: 'Địa chỉ 1', value: 'shippingAddress1' },
        { text: 'Địa chỉ 2', value: 'shippingAddress2' },
        { text: 'Hạn mức công nợ', value: 'creditLimit' },
        { text: 'Cho phép nợ (ngày)', value: 'paymentTermsDays' },
        { text: 'Trạng thái', value: 'status' },
      ],
      filterMapping: {
        name: 'name',
        phoneNo: 'phoneNo',
        type: 'type',
        status: 'status',
      },
    };
  },
  methods: {
    showModal() {
      this.$refs.exportModal.showModal();
    },

    hideModal() {
      this.$refs.exportModal.hideModal();
    },
  },
};
</script>
